import { useEffect, useState } from "react";

import { useAppDispatch } from "@/redux/hooks/hooks";
import { useNotifications } from "@/context/NotificationContext";

type TUsePolling = {
  templateIds: string[];
};

/// This hooks basically checks in the notifications array that in the last second do we
// have any notification that matches the with the template id if id does
// it will poll every second for 2 seconds and it will allow use to refetch the
// api query this how we are managing the the realtime data update

const usePolling = ({ templateIds }: TUsePolling) => {
  const [pollFast, setPollFast] = useState(false);
  const { notifications } = useNotifications();

  const pollingInterval = pollFast ? 1000 : 100000000; // Change to appropriate value for your use case

  useEffect(() => {
    const IsRefetchVideoScript = notifications.find((notification) => {
      const oneSecondAgo = new Date(Date.now() - 2000); // Check last second
      const notificationTime = new Date(notification.createdAt);

      return (
        !notification.isRead &&
        templateIds.includes(notification.template_id) && // Check if template ID is in the passed array
        notificationTime > oneSecondAgo
      );
    });

    if (IsRefetchVideoScript) {
      if (!pollFast) {
        setPollFast(true);
      }
    }
  }, [notifications, pollFast, templateIds]); // Added templateIds to dependency array

  useEffect(() => {
    if (pollFast) {
      const timer = setTimeout(() => {
        setPollFast(false);
      }, 2000);
      return () => clearTimeout(timer); // Cleanup timeout on unmount
    }
  }, [pollFast]);

  return { pollingInterval };
};

export default usePolling;
